<script lang="ts">
    import IconCancel from './Icons/IconCancel.svelte';
    import { onMount } from 'svelte';

    export let query: string;
    export let placeholder: string = '';
    export let onChange: (value: string) => void = (value: string) => {};
    export let onKeyup: (value: string) => void = (value: string) => {};
    export let debounceTime: number = 250;

    let iconCancelInvisible: boolean = false;

    let timer: any = null;

    const debounce = (fn: () => void) => {
        if (timer) clearTimeout(timer);
        timer = setTimeout(() => {
            console.log('debounce', query);
            fn();
        }, debounceTime);
    };

    onMount(() => {
        return () => {
            if (timer) clearTimeout(timer);
        };
    });

    $: {
        iconCancelInvisible = query.length === 0;
    }
</script>

<div style="display: flex; align-items: center; position: relative;">
    <div class="search-input-container">
        <input
            type="text"
            class="search-input"
            {placeholder}
            bind:value={query}
            on:change={() => {
                // console.log('SearchInput, debounce, change', query);
                // debounce(()=>{onChange(query);})
            }}
            on:keyup={() => {
                console.log('SearchInput, debounce, keyup', query);
                debounce(() => {
                    onKeyup(query);
                });
            }}
            autofocus={true}
        />
        <div class="search-input-icon-magnitude"></div>
    </div>
    <div class:iconCancelInvisible style="position: absolute; right: 3px; opacity: 0.7;">
        <IconCancel
            scale={0.7}
            on:click={() => {
                if (iconCancelInvisible) return;
                query = '';
                onChange(query);
                onKeyup(query);
            }}
        />
    </div>
</div>

<style>
    .search-input-container {
        /*width: 100%;*/
        margin: 0 0 0 0;
        position: relative;
        box-sizing: border-box;
    }
    .search-input-container .search-input {
        /*width: 200px;*/
        width: 98%;
        height: 30px;
        border-radius: 6px;
        background-color: #ffffff;
        border: 2px solid #00000033;
        font-size: 0.9rem;
        padding: 0 0 0 30px;
        /*box-shadow: 0px 0px 10px 10px red;*/
    }
    .search-input-container .search-input-icon-magnitude {
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' height='48' viewBox='0 -960 960 960' width='48'%3E%3Cpath d='M796-121 533-384q-30 26-69.959 40.5T378-329q-108.162 0-183.081-75Q120-479 120-585t75-181q75-75 181.5-75t181 75Q632-691 632-584.85 632-542 618-502q-14 40-42 75l264 262-44 44ZM377-389q81.25 0 138.125-57.5T572-585q0-81-56.875-138.5T377-781q-82.083 0-139.542 57.5Q180-666 180-585t57.458 138.5Q294.917-389 377-389Z'/%3E%3C/svg%3E");
        position: absolute;
        top: 7px;
        left: 5px;
        width: 18px;
        height: 18px;
        background-size: 18px;
        background-repeat: no-repeat;
    }
    .iconCancelInvisible {
        visibility: hidden;
    }
</style>
